/**
 * Wrapper for ga()
 * See https://developers.google.com/analytics/devguides/collection/analyticsjs/events
 */
export default (eventCategory, eventAction, eventLabel, eventValue, fieldsObject) => {
    if (typeof ga === "function") {
        // TODO Figure out how to do this with GTM dataLayer.
        ga(() => {
            const tracker = ga.getAll()[0];
            if (tracker) {
                tracker.send("event", eventCategory, eventAction, eventLabel, eventValue, fieldsObject);
            }
        });
    }
};
